<template>
  <div class="row" >
        <div class="col-md-1">
        </div>
        <div class="col-md-10 card py-4">
        	<div class="row">
        		<div class="col-md-12">
	        		<div class="container text-center mb-4">
	        			<h4>{{$t('lang.preparingapp.title')}}</h4>
	        			<span>{{$t('lang.preparingapp.subtitle')}}</span>
	        		</div>
        		</div>
        	</div>
    		<div class="row mt-3" v-if="isBilling">
        		<div class="col-md-1">
        		</div>
        		<div class="col-md-10">
	        		<div class="container card w100 p-4">
	        			<div class="row">
		        			<div class="col-md-12">
                                <div class="float-left">
                                    <small><small class="p-1 rounded-circle icon-checkmark bg-primary text-white"></small></small>
                                </div>
                                <div class="ml-4 mt-1">
    		        				<h6>{{$t('lang.preparingapp.prepare')}}</h6>
    		        				<button
                                    @click="$router.push('/orders')"
                                    class="float-right btn btn-sm btn-outline-primary">{{$t('lang.preparingapp.prepare_btn')}}</button>
    		        				<small class="text-secondary">{{$t('lang.preparingapp.prepare_desc')}}</small>
                                </div>
		        			</div>
	        			</div>
	        		</div>
        		</div>
        		<div class="col-md-1">
        		</div>
    		</div>
    		<div class="row mt-3">
        		<div class="col-md-1">
        		</div>
        		<div class="col-md-10">
	        		<div class="container card w100 p-4">
	        			<div class="row">
		        			<div class="col-md-12">
                                    <ClientTeam :simplify="true"/>
		        			</div>
	        			</div>
	        		</div>
        		</div>
        		<div class="col-md-1">
        		</div>
    		</div>
    		<div class="row mt-3" v-if="isBilling">
        		<div class="col-md-1">
        		</div>
        		<div class="col-md-10">
	        		<div class="container card w100 p-4">
	        			<div class="row">
		        			<div class="col-md-12">
                                <div class="float-left">
                                    <small v-if="words.length == 0" class="rounded-circle icon-checkmark bg-white border-secondary border text-white"></small>
                                    <small v-else><small class="p-1 rounded-circle icon-checkmark bg-primary text-white"></small></small>
                                </div>
                                <div class="ml-4 mt-1">
    		        				<h6>{{$t('lang.preparingapp.uploaddomain')}}</h6>
    		        				<button
                                    @click="$router.push('/settings-account?blacklist=1')"
                                    :class="words.length == 0 ? 'btn-primary' : 'btn-outline-primary'"
                                     class="float-right btn btn-sm">
                                     {{$t('lang.preparingapp.uploaddomain_btn')}}
                                    </button>
    		        				<small class="text-secondary">{{$t('lang.preparingapp.uploaddomain_desc')}}</small>
                                </div>
		        			</div>
	        			</div>
	        		</div>
        		</div>
        		<div class="col-md-1">
        		</div>
    		</div>

			<div class="row mt-3">
        		<div class="col-md-1">
        		</div>
        		<div class="col-md-10">
	        		<div class="container card w100 p-4">
	        			<div class="row">
		        			<div class="col-md-12">
                    <ClientTeam
                    :listProfileComplete="true"
                    :isBillingSaleOrSales="isBillingSaleOrSales"
                    :isSales="isSales"/>
		        			</div>
	        			</div>
	        		</div>
        		</div>
        		<div class="col-md-1">
        		</div>
    		</div>
        </div>
        <div class="col-md-1">
        </div>
  </div>
</template>

<script>
import ClientTeam from "@/components/Account/ClientTeam.vue";
import { clientsService } from "@/_services";

export default {
	props:{
		user: { type: Object }
	},
    data(){
        return {
            words: []
        }
    },
    components:{
        ClientTeam
    },
	computed: {
		isBilling(){
			const isBilling  = (this.user.role_id == 4 ) ? true : false
			return isBilling
		},
		isBillingSaleOrSales(){
			const isBillingSaleOrSales  = ( (this.user.role_id == 4 && this.user.sales_representative_id != null) || this.user.role_id == 3) ? true : false
			return isBillingSaleOrSales
		},
		isSales(){
			return (this.user.role_id == 3) ? true : false
		}
	},
    created(){
        clientsService.getBlacklist().then((result) => {
            this.words = result.words
        });
    },
};
</script>
